type Size = {
    width: number;
    height: number;
};

function getScrollbarSize() {
    const element = window.document.createElement('textarea') as HTMLTextAreaElement,
        style = {
            visibility: 'hidden',
            position: 'absolute',
            zIndex: '-1',
            top: '-1000px',
            left: '-1000px',
            width: '100px',
            height: '100px',
            overflow: 'scroll',
            margin: '0',
            border: '0',
            padding: '0',
        },
        support = element.clientWidth !== undefined && element.offsetWidth !== undefined;

    for (let key in style) {
        if (style.hasOwnProperty(key)) {
            (element.style as any)[key] = (style as any)[key];
        }
    }

    const size: Size = {
        width: 0,
        height: 0,
    };

    if (support && window.document.body) {
        window.document.body.appendChild(element);
        size.width = element.offsetWidth - element.clientWidth;
        size.height = element.offsetHeight - element.clientHeight;
        window.document.body.removeChild(element);
    }

    return size;
}

export function setBodyOverflow() {
    const { width } = getScrollbarSize();

    document.body.classList.add('scroll-disabled');
    document.body.style.paddingRight = width + 'px';
}

export function unsetBodyOverflow() {
    document.body.classList.remove('scroll-disabled');
    document.body.style.paddingRight = '0';
}
